import { SelectOption } from "atoms/forms/select";
import UserBookmarkShareFilterOption from "models/enumerations/filtering/user-bookmarks/user-bookmark-share-filter-option";
import SelectFormField from "molecules/form-fields/select-form-field";
import React from "react";
import { ShareFilterValueToNameMap } from "utilities/bookmark-utils";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import { t } from "utilities/localization-utils";
import StringUtils from "utilities/string-utils";
interface FilterByShareStatusProps {
    shareStatus?: UserBookmarkShareFilterOption;
    onChange: (option: SelectOption | undefined) => void;
}

const FilterByShareStatus = ({
    shareStatus,
    onChange,
}: FilterByShareStatusProps) => {
    const { currentIdentity } = useCurrentIdentity();
    const isMemberOfTeam = currentIdentity?.isGroupMember();

    const options: SelectOption[] = [
        {
            data: UserBookmarkShareFilterOption.All,
            value: UserBookmarkShareFilterOption.All.toString(),
            label: StringUtils.capitalize(
                t(ShareFilterValueToNameMap[UserBookmarkShareFilterOption.All])
            ),
        },
        {
            data: UserBookmarkShareFilterOption.PrivateOnly,
            value: UserBookmarkShareFilterOption.PrivateOnly.toString(),
            label: t(
                ShareFilterValueToNameMap[
                    UserBookmarkShareFilterOption.PrivateOnly
                ]
            ),
        },
    ];

    const handleOnChange = (newVal: SelectOption | undefined) => {
        onChange(newVal?.data);
    };
    return (
        <>
            {isMemberOfTeam && (
                <SelectFormField
                    ariaLabelOnly
                    label={t("filterBy", { item: "" })}
                    value={shareStatus?.toString()}
                    onChange={handleOnChange}
                    options={options}
                />
            )}
        </>
    );
};

export default FilterByShareStatus;
